<!--
   Created by qing on 2021/4/29
   Des: 透视表
-->
<template>
  <div
    v-if="value && value.header && value.header.length"
    class="statistics__pivotable"
    :key="tableKey">
    <div class="default-table">
      <table>
        <thead>
        <tr
          v-for="row in value.header"
          :key="Math.random()">
          <th
            v-for="header in row"
            :key="Math.random()"
            :rowspan="header.rowspan"
            :colspan="header.colspan">
            <div :style="{width: `${header.colspan * 140}px`}">
              {{header.content}}
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in value.body" :key="Math.random()">
          <td
            v-for="col in row"
            :key="Math.random()"
            :rowspan="col.rowspan"
            :colspan="col.colspan"
            :style="{color: col.color, background: col.background}">
            <div :style="{width: `${col.colspan * 140}px`}">
              {{col.content}}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    v-else
    class="dashboard-empty__container">
    <i class="iconfont icon-nodata"></i>
    <div>暂无数据</div>
  </div>
</template>

<script>
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        tableKey: Math.random()
      }
    },
    created() {

    },
    mounted() {
      this.$nextTick(() => {
      })
    },
    beforeDestroy() {
    },
    methods: {

      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {

        })
      },
    },
    watch: {
      // value 发生修改时 重新渲染图表
      value() {

      }
    }
  }
</script>

<style lang="less">
  .statistics__pivotable {
    height: 100%;
    border: 1px solid #e4e4e4;
    overflow: hidden;

    .default-table {
      width: 100%;
      height: 100%;
      overflow: auto;
    }

    table {
      border-collapse: separate;
      border-spacing: 0;
      width: 100%;
      margin-bottom: 10px;
      text-align: left;
      font-size: 12px;
      color: #4b4b4b;

      thead {

        th {
          color: #5E6D82;
          background-color: #E9E9E9;
          background-clip: padding-box;
          border-color: #FFFFFF;
          border-width: 0 1px 1px 0;
          border-style: solid;
          position: relative;
          vertical-align: middle;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 8px;
          height: 33px;
          font-weight: 400;
          width: 140px;

          > div {
            width: 140px;
            word-wrap:break-word;
            word-break:break-all;
            white-space:normal;
            overflow: hidden;
          }
        }
      }

      tbody {
        background: #FFFFFF;

        tr {
          color: #1F2D3D;

          td {
            background-color: rgba(233, 233, 233, 0.05);
            border-color: rgba(233, 233, 233, 0.8);
            border-width: 0 1px 1px 0;
            border-style: solid;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            padding: 8px;
            height: 33px;
            vertical-align: middle;
            font-weight: 400;
            color: #1F2D3D;
            width: 140px;

            > div {
              width: 140px;
              word-wrap:break-word;
              word-break:break-all;
              white-space:normal;
              overflow: hidden;
            }
          }
        }
      }
    }

    table tbody tr:nth-child(odd) {
      background: #ffffff;
    }

    table tbody tr:nth-child(even) {
      background: rgb(248, 248, 248);
    }


    .fixed-table-container {
      position: relative;
      width: 100%;
      height: 100%;

      table {
        margin-bottom: 0;
      }

      .table__header-wrapper {
        overflow-y: hidden;
        overflow-x: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
      }

      .table__fixed {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 15px;
        z-index: 1;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .table-content-container {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 15px;
        right: 0;
        z-index: -1;
        overflow: hidden;
      }

      .fixed-top-header {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 3;
        font-size: 12px;

        tr {
          /*display: flex;*/
        }

        th  {
          width: auto;
          > div {
            width: 140px;
            word-wrap:break-word;
            word-break:break-all;
            white-space:normal;
            overflow: hidden;
          }
        }

      }
    }

    .row-fixed {

      .table__header-wrapper {
        z-index: 1;
        overflow: hidden;
        bottom: auto;
        right: 15px;
      }

      .table-content-container {
        z-index: 0;
        overflow: auto;
        /*padding-right: 15px;*/
      }
    }

    .col-fixed {

      .table__fixed {
        z-index: 1;
        overflow: hidden;
        bottom: 15px;
      }

      .table-content-container {
        z-index: 0;
        overflow: auto;
        bottom: 0;
      }
    }
  }
</style>
